import React from 'react';

/**
 * About Page 
 */
const AboutPage = () => (
   <section className="about page-section">
      <div className="page-container">
         <div className="page-title-wrapper">
            <h2 className="page-title">About.</h2>
         </div>
         <p className="page-subtitle">"tincidunt vel pulvinar at"</p>
         <p className="about__copy">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed maximus, augue porttitor pulvinar efficitur, turpis nulla rhoncus libero, non ultrices nisl nisi quis ante. Aenean dictum nisl metus, id convallis nulla bibendum sed. Nullam iaculis lorem sed lectus efficitur dignissim. Praesent vitae malesuada elit, a posuere felis. Praesent a fermentum mi. Nulla ac ultricies diam. Vestibulum interdum facilisis est. Integer nec convallis metus. Fusce sed sapien nulla.
         </p>
         {/* <p className="page-subtitle">Welcome to Toronto Live.</p>
			<p className="about__copy">
				Toronto Live was created to provide a modern platform that allows users to search upcoming concerts in Toronto. Currently pulling in all data from Ticketmaster's API, each event displays the concert date, headliner artist image, venue, and time. Additional details can be viewed by clicking any event from the search results.
			</p>
			<p className="about__copy">
				The next steps for Toronto Live are a custom api build, allowing bulk entries of concert data to be added. This will allow for users to be capable of browsing all concerts instead of being limited to only shows that have tickets sold on Ticketmaster.
			</p> */}
      </div>
   </section>
);

export default AboutPage;